import { render, staticRenderFns } from "./BetriebswirtschaftlicheAuswertung.vue?vue&type=template&id=2609213c&"
import script from "./BetriebswirtschaftlicheAuswertung.vue?vue&type=script&lang=ts&"
export * from "./BetriebswirtschaftlicheAuswertung.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports